<template>
  <el-container> <!-- v-if="isLayoutReady"s -->
    <el-header v-if="!isBlank">
      <LayoutTop />
    </el-header>
    <el-container v-if="!isBlank" style="overflow: hidden">
      <el-aside width="180px">
        <LayoutLeft></LayoutLeft>
      </el-aside>
      <el-main>
        <el-container>
          <LayoutTab></LayoutTab>
        </el-container>
        <router-view></router-view>
      </el-main>
    </el-container>
    <router-view v-if="isBlank" :key="$route.fullPath"></router-view>
  </el-container>
</template>

<script>
import LayoutTop from "./layoutTop";
import LayoutLeft from "./layoutLeft";
import LayoutTab from "./layoutTab";
export default {
  name: "app",
  components: {
    LayoutTop,
    LayoutLeft,
    LayoutTab,
  },
  computed: {
    isBlank() {
      let isBlank = this.$route.meta && this.$route.meta.isBlank === true;
      return isBlank;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.isLayoutReady = false; // 先隐藏
        this.$nextTick(() => {
          this.isLayoutReady = true; // 再显示
        });
      },
    },
  },
  data() {
    return {
      isLayoutReady: false,
    };
  },
  methods: {

  },
};
</script>

<style scoped>
html,
body {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  width: 100%;
  height: 100%;
}
.el-header {
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  background: #003664;
  color: #fff;
  z-index: 2;
}
.el-aside {
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.el-main {
  background: #f0f2f5;
  box-sizing: border-box;
}
</style>
